'use strict';
var baseSearch = require('core/search/search'); // $.extend({}, require('core/search/search'));
 var wishlistBase = require('../wishlist/wishlist');

baseSearch.handleContinuousScroll = function() {
    // console.log("In Handle Continuous Scroll - Hey there");
    const clientConfig = window.CachedData.clientConfig;
    if (!window.isMobile() && clientConfig.enableContinuousScroll.value == "desktop") {
        addScrollToListener();
    } else if (window.isMobile() && clientConfig.enableContinuousScroll.value == 'mobile') {
        addScrollToListener();
    } else if (clientConfig.enableContinuousScroll.value == 'both') {
        addScrollToListener();
    }
    // add the listeners for toggling the button text when scroll activated or when the button is clicked
    searchShowMoreListener();
    searchShowMoreSuccessListener();
}

// some "global" variables
var loadingProducts = false;
var buttonOffset = null;
var continuousScrollEnabled = false;
var scrollListener = function () {
    var bottomWindow = window.outerHeight + window.pageYOffset;
    if (bottomWindow > buttonOffset && !loadingProducts) {
        loadingProducts = true;
        // trigger the click
        $('.container .show-more button').trigger('click');
    }
};

function addScrollToListener() {
    continuousScrollEnabled = true;
    // get the button position
    buttonOffset = $('.show-more button').offset().top + 200;
    window.addEventListener('scrollUpdate', scrollListener);
}

function searchShowMoreListener() {
    $('.container .show-more button').on('search:showMore', () => {
        // even when continuous scroll is disabled we are still toggling the text of the button
        var $button = $('.show-more button');
        $button.text($button.data('loading-text'));
        if (!$button.hasClass('disabled')) {
            $button.addClass('disabled');
        }
    });
}

function searchShowMoreSuccessListener() {
    $('body').on('search:showMore--success', () => {
        // even when continuous scroll is disabled we are still toggling the text of the button
        var $button = $('.show-more button');
        if ($button.length > 0) {
            $button.text($button.data('text'));
            if (continuousScrollEnabled) {
                // reset the button offsets
                buttonOffset = $button.offset().top + 200;
                loadingProducts = false;
                if ($button.hasClass('disabled')) {
                    $button.removeClass('disabled');
                }
            }
            var lastPage = $button.data('last-page');
            if (lastPage !== true) {
                // rebind the searchShowMoreListener, because the event is bound on the button not .container or body (this is a carry over from app_storefront_base)
                searchShowMoreListener();
            } else {
                window.removeEventListener('scrollUpdate', scrollListener);
            }
        } else {
            window.removeEventListener('scrollUpdate', scrollListener);;
        }
    });
}

// grab the site pref integration object
var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
var toggleObject = siteIntegrations.getIntegrationSettings();

if (toggleObject.yotpoCartridgeEnabled) {
    $('body').on('search:showMore--success search:filter--success search:sort--success', () => {
        if (window.yotpo) {
            window.yotpo.refreshWidgets();
        }
    });
}

var baseSearchShowMore = baseSearch.showMore;
baseSearch.showMore = function () {
    $('body').on('search:showMore--success', () => wishlistBase.updateWishlistLinkData());

    return baseSearchShowMore.apply(this, arguments);
};

module.exports = baseSearch;
